<template>
  <nav class="navbar fixed-top bg-dark navbar-expand-md">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img :src="require('@/assets/img/logo_pno.png')" class="d-inline-block" alt="PNO Trailer Rental and Sharing" width="44" height="40" />
        <span class="navbar-brand-desc d-inline ml-2">Trailer Rental</span>
      </router-link>
      <a class="navbar-toggler" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fal fa-lg fa-bars"></i>
      </a>
      <div class="collapse navbar-collapse" id="navbarNav">
        <br class="d-md-none">
        <ul class="navbar-nav">
          <li class="nav-item mx-1 ml-md-2 ml-lg-5">
            <router-link class="nav-link ml-lg-2 ml-xl-5 pl-xl-3" to="/trailers">Search trailers</router-link>
          </li>
          <li class="nav-item mx-1">
            <router-link class="nav-link" to="/compare">Rental vs. buying</router-link>
          </li>
          <li class="nav-item mx-1 d-md-none">
            <router-link class="nav-link" to="/about">About us</router-link>
          </li>
          <li class="nav-item mx-1 d-md-none">
            <a class="nav-link" href="https://pnorental.com/contact/">Contact</a>
          </li>
          <li class="nav-item dropdown mx-1 d-none d-md-inline">
            <a class="nav-link nav-info" href="#" id="navbarInfo" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-lg fa-ellipsis-h d-none d-md-inline"></i> <span class="d-md-none">About</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarInfo">
              <router-link class="dropdown-item px-3" to="/about">About us</router-link>
              <a class="dropdown-item px-3" href="https://pnorental.com/contact/">Contact</a>
            </div>
          </li>
        </ul>
        <hr>
        <ul class="navbar-nav ml-auto">
		      <li class="nav-item mx-1">
		        <router-link class="nav-link nav-quote" to="/booking">
              <span v-if="itemsInQuote > 0" class="noti rounded-circle">{{ itemsInQuote }}</span>
							<i class="fas fa-list-alt"></i>
							Quote
		        </router-link>
		      </li>
        </ul>
        <br class="d-md-none">
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapState('user', ['isLoggedIn']),
      ...mapState('app', ['loginUrl', 'logoutUrl']),
      ...mapGetters('quote', ['itemsInQuote']),
    },
  }
</script>
